import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityPath, Protocol, url } from '@environments/environment';
import { IAerobicCapacityRealizedProtocols, IAssessmentsByIdAnon, IBodyCompositionProtocols, IPhysicalAssessments } from '@app-physical-assessments/data-access/entities/physical-assessments.interface';

@Injectable({
  providedIn: 'root'
})
export class PhysicalAssessmentsService {
  private http = inject(HttpClient);

  public getPhysicalAssessments(personId: string): Observable<IPhysicalAssessments> {
    return this.http.get<IPhysicalAssessments>(url(Protocol.https, EntityPath.physical_assessment_service, '/Assessment/GetSummaryAssessmentsByPersonId'), {
      params: {
        personId
      },
      withCredentials: true
    });
  }

  public getPhysicalAssessmentById(assessmentId: string): Observable<IAssessmentsByIdAnon> {
    return this.http.get<IAssessmentsByIdAnon>(url(Protocol.https, EntityPath.physical_assessment_service, '/Assessment/GetAssessmentsByIdAnon'), {
      params: {
        assessmentId
      },
      withCredentials: true
    });
  }

  public getBodyCompositionProtocolById(id: number): Observable<IBodyCompositionProtocols> {
    return this.http.get<IBodyCompositionProtocols>(url(Protocol.https, EntityPath.physical_assessment_service, '/BodyComposition/GetBodyCompositionProtocolById'), {
      params: {
        id
      },
      withCredentials: true
    });
  }

  public getAerobicCapacityRealizedProtocolById(id: number): Observable<IAerobicCapacityRealizedProtocols> {
    return this.http.get<any>(url(Protocol.https, EntityPath.physical_assessment_service, '/AerobicCapacity/GetAerobicCapacityRealizedProtocolById'), {
      params: {
        id
      },
      withCredentials: true
    });
  }
}
